<dx-scroll-view
  class="scrollable-board"
  direction="both"
  showScrollbar="always"
>
  <dx-sortable
    class="sortable-lists"
    itemOrientation="horizontal"
    handle=".list-title"
    (onReorder)="onListReorder($event)"
  >
    <div class="list" *ngFor="let board of kanbanDataSource">
      <div class="list-title dx-theme-text-color">
        <span>{{ board.name }}</span>
        <dk-task-card-menu [items]="boardMenuItems"> </dk-task-card-menu>
      </div>
      <dx-scroll-view
        class="scrollable-list"
        direction="vertical"
        showScrollbar="always"
      >
        <dx-sortable
          class="sortable-cards"
          group="cardsGroup"
          [data]="board"
          (onDragStart)="onTaskDragStart($event)"
          (onReorder)="onTaskDrop($event)"
          (onAdd)="onTaskDrop($event)"
        >
          <ng-container *ngFor="let task of board.cards">
            <dk-task-kanban-card
              class="dx-card"
              [task]="task"
            ></dk-task-kanban-card>
          </ng-container>
        </dx-sortable>

        <div class="add-task">
          <dx-button
            icon="plus"
            text="Görev Ekle"
            stylingMode="text"
            width="100%"
            (onClick)="addTask()"
          ></dx-button>
        </div>
      </dx-scroll-view>
    </div>
  </dx-sortable>
</dx-scroll-view>
